import * as React from 'react'
import { StoreComponent, injectStores } from '../../../store'
import { observer } from 'mobx-react'

import * as videojs from 'video.js'
require('video.js/dist/video-js.css')

import * as classnames from 'classnames'
import { PlayerOnly, ITextTracks } from './videoplayer'

import * as styles from './bgVideoPlayer.css'
import { replaceFilename } from '../../../utils/StringUtils'

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'video-js': any
    }
  }
}

interface IProps extends React.HTMLAttributes<HTMLVideoElement> {
  src: string
  isBg?: boolean
}

@injectStores
@observer
export class BGVideoPlayer extends StoreComponent<IProps> {
  videoElement: HTMLVideoElement | null
  videoJs: videojs.Player

  render () {

    const tracks: ITextTracks[] | undefined = this.store.storeCommon.menu.language === 'en' ? [{
      src: this.props.src.replace(/playlist.m3u8/, 'en.vtt'),
      // src: 'https://storage.googleapis.com/adenauer-web/Videos/vertiefungen/Kapitel4/4_3_RedeAdenauersDeutschland-EVG-Vertrag/en.vtt',
      srclang: 'en'
    }] : undefined
    const cl = classnames(styles.player)
    return (
      <PlayerOnly
        poster={replaceFilename(this.props.src, 'firstframe.jpg')}
        className={cl}
        controls
        play={this.store.storeCommon.currentStory.id == null && !this.store.storeCommon.currentStory.paused}
        loop={this.props.isBg ? true : false}
        muted={this.props.isBg ? true : false}
        fluid={false}
        src={this.props.src}
        // isBg={this.props.isBg}
        videoended={() => this.store.storeCommon.currentStory.play = false}
        textTracks={tracks}
        textTracksDisplay={this.store.storeCommon.menu.language}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/video/bgVideoPlayer.tsx